import api from './api';

const TTL_MS = 6000;
const SESSION_PREFIX = 'wrg.tradingVault.v1.';

const memory = new Map();
const inflight = new Map();

function walletKey(addr) {
  return String(addr || '').toLowerCase();
}

export function peekTradingVault(walletAddress) {
  const key = walletKey(walletAddress);
  if (!key) return null;
  const mem = memory.get(key);
  if (mem?.data) return mem.data;
  try {
    const raw = sessionStorage.getItem(`${SESSION_PREFIX}${key}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.data) {
      memory.set(key, { at: parsed.at || 0, data: parsed.data });
      return parsed.data;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function putTradingVault(walletAddress, data) {
  const key = walletKey(walletAddress);
  if (!key || !data) return;
  const rec = { at: Date.now(), data };
  memory.set(key, rec);
  try {
    sessionStorage.setItem(`${SESSION_PREFIX}${key}`, JSON.stringify(rec));
  } catch {
    /* ignore quota */
  }
}

export function isTradingVaultFresh(walletAddress, ttl = TTL_MS) {
  const key = walletKey(walletAddress);
  const mem = memory.get(key);
  return !!(mem && Date.now() - mem.at < ttl);
}

export function invalidateTradingVault(walletAddress) {
  const key = walletKey(walletAddress);
  if (!key) {
    memory.clear();
    return;
  }
  memory.delete(key);
  try {
    sessionStorage.removeItem(`${SESSION_PREFIX}${key}`);
  } catch {
    /* ignore */
  }
}

export async function fetchTradingVaultFromApi(walletAddress, { timeout = 10000, force = false } = {}) {
  const key = walletKey(walletAddress);
  if (!key) return null;
  if (!force && isTradingVaultFresh(key)) {
    return peekTradingVault(key);
  }
  if (inflight.has(key)) return inflight.get(key);

  const work = (async () => {
    const { data } = await api.get('/orderbook/vault', {
      params: {
        walletAddress,
        ...(force ? { fresh: '1' } : {}),
      },
      timeout,
    });
    const payload = data || {};
    putTradingVault(key, payload);
    return payload;
  })();

  inflight.set(key, work);
  try {
    return await work;
  } finally {
    if (inflight.get(key) === work) inflight.delete(key);
  }
}
